import { Inject, Injectable } from '@angular/core';

import { PermissionService } from '../services/permission.service';
import {
  LANGUAGE_PREVIEW_PERMISSION,
  LANGUAGE_RELEASE,
  LanguageReleaseSwitch
} from './language-release';

/**
 * Decides whether the signed-in account is a language tester (AB#19412).
 *
 * Preview languages are offered only on a build that allows previews (environment.languagePreview)
 * AND to an account that holds LANGUAGE_PREVIEW_PERMISSION. A production build never asks the API.
 * Nothing here reads or writes a stored language preference.
 */
@Injectable({ providedIn: 'root' })
export class LanguagePreviewAccessService {
  constructor(
    private readonly permissions: PermissionService,
    @Inject(LANGUAGE_RELEASE) private readonly release: LanguageReleaseSwitch
  ) {}

  /** Re-reads the tester signal for the account now signed in (or none) and applies it to the switch. */
  async refresh(signedIn: boolean): Promise<boolean> {
    let granted = false;
    if (signedIn && this.release.previewBuild) {
      // PermissionService answers false on any failure, so an API error never shows a preview.
      granted = await this.permissions.has(LANGUAGE_PREVIEW_PERMISSION);
    }
    this.release.setPreviewAccess(granted);
    return this.release.includePreview;
  }
}
